import { cn } from '@/utils'

const themes = {
  success: { bg: 'bg-emerald-200/50', progress: 'bg-emerald-500' },
  error: { bg: 'bg-red-50', progress: 'bg-red-700' },
}

const borderedThemes = {
  success: 'border border-emerald-200 bg-muted',
  error: 'border border-red-200 bg-muted',
}

interface ProgressBarProps {
  progress: number
  bordered?: boolean
  theme?: 'success' | 'error'
  className?: string
  progressClassName?: string
}

export const ProgressBar = ({
  className,
  progress,
  theme = 'success',
  bordered = false,
  progressClassName = '',
}: ProgressBarProps) => {
  const themeClasses = themes[theme]
  return (
    <div
      className={cn(
        'box-content h-2.5 w-full overflow-hidden rounded-[50px]',
        themeClasses.bg,
        bordered && borderedThemes[theme],
        className,
      )}
    >
      <div
        className={cn(
          'h-2.5 rounded-[50px]',
          themeClasses.progress,
          progressClassName,
        )}
        style={{ width: `${progress}%` }}
      ></div>
    </div>
  )
}
